"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetAttributes {
    static getAttributeTypeMap() {
        return GetAttributes.attributeTypeMap;
    }
}
GetAttributes.discriminator = undefined;
GetAttributes.attributeTypeMap = [
    {
        "name": "attributes",
        "baseName": "attributes",
        "type": "Array<GetAttributesAttributes>"
    }
];
exports.GetAttributes = GetAttributes;
//# sourceMappingURL=getAttributes.js.map